// Eagerly bundle every English namespace into a single object the
// IntlProvider receives. Mirrors the shape next-intl loaded via
// getRequestConfig — keeps consumer code (`useTranslations('Auth')`)
// identical. Add a new namespace here when you add the JSON file under
// `messages/en/`.
import Admin from '../../messages/en/admin.json';
import Assistant from '../../messages/en/assistant.json';
import Attached from '../../messages/en/attached.json';
import Auth from '../../messages/en/auth.json';
import Circles from '../../messages/en/circles.json';
import Common from '../../messages/en/common.json';
import Directory from '../../messages/en/directory.json';
import Errors from '../../messages/en/errors.json';
import Events from '../../messages/en/events.json';
import Feed from '../../messages/en/feed.json';
import Feedback from '../../messages/en/feedback.json';
import Group from '../../messages/en/group.json';
import Invitations from '../../messages/en/invitations.json';
import LearningTracks from '../../messages/en/learningTracks.json';
import Legal from '../../messages/en/legal.json';
import Members from '../../messages/en/members.json';
import MessagesNS from '../../messages/en/messages.json';
import Moderation from '../../messages/en/moderation.json';
import Networks from '../../messages/en/networks.json';
import Notifications from '../../messages/en/notifications.json';
import Onboarding from '../../messages/en/onboarding.json';
import Profile from '../../messages/en/profile.json';
import Resources from '../../messages/en/resources.json';
import Search from '../../messages/en/search.json';
import Settings from '../../messages/en/settings.json';
import Shell from '../../messages/en/shell.json';
import Spaces from '../../messages/en/spaces.json';

const messages = {
  Admin,
  Assistant,
  Attached,
  Auth,
  Circles,
  Common,
  Directory,
  Errors,
  Events,
  Feed,
  Feedback,
  Group,
  Invitations,
  LearningTracks,
  Legal,
  Members,
  Messages: MessagesNS,
  Moderation,
  Networks,
  Notifications,
  Onboarding,
  Profile,
  Resources,
  Search,
  Settings,
  Shell,
  Spaces,
};

export default messages;
export type Messages = typeof messages;
